import React from 'react';
import { Reveal } from './ui/Reveal';
import { problems } from '../data/content';
export function ProblemSection() {
  return <section aria-labelledby="problema" className="bg-tint text-ink" data-id="element-126" data-mp="2ltmglpx0jlk0">
      <div className="mx-auto max-w-2xl px-3 py-5 text-center sm:px-5" data-id="element-127" data-mp="30hpmz0eywz9c">
        <p className="inline-block rounded-md bg-coral px-2 py-0.5 font-sub text-sm font-semibold text-white" data-id="element-128" data-mp="2vqhgac50vrzv">
          ¿Te suena familiar?
        </p>
        <h2 id="problema" className="mt-2 font-display text-[1.4rem] font-extrabold leading-[1.15] tracking-tight sm:text-3xl" data-id="element-129" data-mp="39gkuqgxnuher">
          Estudias enfermería, pero{' '}
          <span className="bg-blush px-1" data-id="element-130" data-mp="3jer058ioe5od">
            te cuesta recordar tantos conceptos, medicamentos, valores de
            laboratorio y procedimientos.
          </span>
        </h2>
        <p className="mx-auto mt-2 max-w-xl text-sm leading-snug text-muted" data-id="element-131" data-mp="1p33s2karw8q1">
          Si estás comenzando la carrera o necesitas preparar exámenes,
          probablemente conozcas alguna de estas situaciones:
        </p>

        <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-132" data-mp="jeyag7urmdy5">
          {problems.map((problem, i) => <Reveal key={problem.title} as="li" delay={i * 0.03} className="flex h-full gap-2.5 rounded-xl border-2 border-ink bg-surface p-2.5 text-left" data-id="element-133" data-mp="ocg7azvid2ps" data-mpi={i}>
              <span className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-lg bg-blush text-base" aria-hidden="true" data-id="element-134" data-mp="123ldkktdst93">
                {problem.emoji}
              </span>
              <div data-id="element-135" data-mp="1c1iwqtwdvzuu">
                <h3 className="font-sub text-sm font-semibold leading-tight" data-id="element-136" data-mp="1c2akxjnnivb3">
                  {problem.title}
                </h3>
                <p className="mt-0.5 text-xs leading-snug text-muted sm:text-sm" data-id="element-137" data-mp="1g11jlv7rml0b">
                  {problem.desc}
                </p>
              </div>
            </Reveal>)}
        </ul>
      </div>
    </section>;
}